export const eventCategories = [
  { label: "Alwadi", value: "Alwadi" },
  { label: "Happening Now", value: "Happening Now" },
  { label: "Upcoming Events", value: "Upcoming Events" },
];

export const directoryCategories = [
  { label: "Fine Dining", value: "Fine Dining" },
  { label: "Casual Dining", value: "Casual Dining" },
  { label: "Cafes and Coffee Shops", value: "Cafes and Coffee Shops" },
  { label: "Entertainment", value: "Entertainment" },
  { label: "Shopping", value: "Shopping" },
  { label: "Health and Wellness", value: "Health and Wellness" },
];
